import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { BellOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import {
  Avatar,
  Breadcrumb,
  Button,
  Dropdown,
  Layout,
  notification,
  Row,
  Space,
  Typography,
} from "antd";
import appLabel from "../../../config/appLabel";
import { SignOutAction } from "../../../redux/actions/authAction";
import HelpButton from "../../custom/HelpButton";
// import appLabel from "../config/appLabel";
const { Header } = Layout;
const { Link, Text, Title } = Typography;

const close = () => {
  console.log(
    "Notification was closed. Either the close button was clicked or duration time elapsed.",
  );
};

function LayoutHeader(props) {
  //DECLARED VARIABLES
  const {
    userData,
    colorBgContainer,
    collapsed,
    setCollapsed,
    pageItems,
    currentStep,
    SignOutAction: signOut,
    session,
  } = props;
  const { username, roles } = userData;
  const roleName = userData.roles[0].name;
  const [open, setOpen] = useState(false);
  const [displayPageItems, setDisplayPageItems] = useState(pageItems);

  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  useEffect(() => {
    //INSERT DASHBOARD LINK AS THE FIRST ELEMENT
    let temp = [];
    temp.push({ title: <Link to="/dashboard">{appLabel.home}</Link> });
    setDisplayPageItems([...temp, ...pageItems]);
  }, []);

  const handleLogout = async () => {
    await signOut();
    navigate("/sign-in");
  };
  const menuItems = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "My Profile",
      onClick: () => navigate("/profile"),
    },
    // {
    //   key: "settings",
    //   icon: <SettingOutlined />,
    //   label: "Settings",
    //   onClick: () => navigate("/settings"),
    // },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined style={{ color: "#ff4d4f" }} />,
      label: <span style={{ color: "#ff4d4f" }}>Logout</span>,
      onClick: handleLogout,
    },
  ];

  const openNotification = () => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <Button type="link" size="small" onClick={() => api.destroy()}>
          Destroy All
        </Button>
        <Button type="primary" size="small" onClick={() => api.destroy(key)}>
          Confirm
        </Button>
      </Space>
    );

    api.open({
      message: "Notification Title",
      description:
        'A function will be be called after the notification is closed (automatically after the "duration" time of manually).',
      btn,
      key,
      onClose: close,
    });
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Header
      style={{
        paddingLeft: 25,
        background: colorBgContainer,
        display: "flex",
        alignItems: "center",
        backgroundColor: "#F7F9FC",
      }}
    >
      <Breadcrumb items={displayPageItems} />
      <Row
        style={{
          marginLeft: "auto",
          marginRight: 20,
          alignItems: "center",
        }}
      >
        {/* Help Button */}
        <HelpButton
          style={{
            marginRight: 8,
          }}
          currentStep={currentStep}
        />
        {contextHolder}
        <Button
          type="text"
          icon={<BellOutlined />}
          onClick={openNotification}
          style={{
            fontSize: "16px",
            width: 50,
            height: 64,
          }}
        />
        <Dropdown menu={{ items: menuItems }} placement="bottomRight" arrow trigger={["click"]}>
          <div
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Avatar
              icon={<UserOutlined className="of-user-icon" />}
              style={{
                fontSize: "16px",
                width: 50,
                height: 64,
                backgroundColor: "transparent",
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                lineHeight: "1.2",
              }}
            >
              <Title level={5} style={{ margin: 0 }}>
                {username || "User"}
              </Title>
              <span style={{ color: "#rgba(255,255,255,0.7)", fontSize: "12px" }}>
                {roleName || "Role"}
              </span>
            </div>
          </div>
        </Dropdown>
      </Row>
    </Header>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

const mapDispatchToProps = { SignOutAction };

export default connect(mapStateToProps, mapDispatchToProps)(LayoutHeader);
